export const SET_FY='SET_FY';

export function setFy(fy) {
    return { type: SET_FY, fy };
}

